export const scrollTo = (className: string) => {
    document.getElementsByClassName(className)[0].scrollIntoView({behavior: 'smooth'})
}
